import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SupplementInstallation = Loadable(lazy(() => import("./SupplementInstallation")));

const SupplementInstallationRoute = [{ path: "/SupplementInstallation", element: <SupplementInstallation /> }];
export default SupplementInstallationRoute;
